export const defaults = {
  apiKey: null,
  defaultMarker: null,
  markerIcon: null,
  clusterer: {
    enabled: false,
    config: {},
  },
  mapOptions: {},
  marksers: [],
  center: null,
  bounds: false,
  zoom: 1,
  events: {},
}
